module.exports = __webpack_public_path__ + "static/img/order-background-Mint.c4a54c0e.jpg";